export const WHATSAPP_NODE_TYPES = ['sendWhatsapp', 'sendWhatsappTemplate'];
export const WEBSEARCH_NODE_TYPES = ['webSearch'];
export const VOICE_NODE_TYPES = ['transferCall', 'endCall'];
// Connettori che portano una chiamata vocale a cui i nodi voce possono agire.
export const VOICE_CONNECTOR_TYPES = ['voicebot', 'gptlive'];

/** @param {Array<{ type: string, enabled?: boolean }>} [connectors] */
export function isVoiceChannelActive(connectors = []) {
  return (connectors || []).some((c) => VOICE_CONNECTOR_TYPES.includes(c?.type) && c.enabled === true);
}

/**
 * Rimuove i nodi WhatsApp/Ricerca Web/Voce dalle categorie della palette
 * quando la relativa feature non è attiva, scartando le categorie rimaste
 * senza nodi. Opera su `nodes[].type`, indipendente dalla forma della
 * categoria (key/label). Non muta l'input.
 * @param {Array} categories
 * @param {{ whatsappActive?: boolean, webSearchActive?: boolean, voiceActive?: boolean }} [opts]
 */
export function filterPaletteCategories(categories, { whatsappActive = false, webSearchActive = false, voiceActive = false } = {}) {
  const excluded = [
    ...(whatsappActive ? [] : WHATSAPP_NODE_TYPES),
    ...(webSearchActive ? [] : WEBSEARCH_NODE_TYPES),
    ...(voiceActive ? [] : VOICE_NODE_TYPES),
  ];
  if (!excluded.length) return categories;
  return categories
    .map((c) => ({ ...c, nodes: c.nodes.filter((n) => !excluded.includes(n.type)) }))
    .filter((c) => c.nodes.length > 0);
}
